import {InjectionToken} from '@angular/core';

export const MM_CONFIG = new InjectionToken('mydocma-mm-config');

export interface MMConfig {
  apiUrl: string;
}
